import API_URL from '../config/apiUrl';
import type { SessionResponse } from '../types';
import { getAnonymousUserId } from '../utils/userId';
import { createSessionId } from '../utils/sessionId';
import { detectPlatform } from '../utils/platform';
import { GAME_CONFIG } from '../config/gameConfig';

export interface SessionParams {
  platform?: 'desktop' | 'mobile';
  trafficSource?: string;
  urlVersion?: string | null;
}

export async function startSession(params: SessionParams = {}): Promise<SessionResponse> {
  const anonymousUserId = getAnonymousUserId();
  const sessionId = createSessionId();
  const platform = params.platform || detectPlatform();
  const trafficSource = params.trafficSource || getTrafficSource();
  const urlVersion = params.urlVersion || getUrlVersion();

  const defaultResponse: SessionResponse = {
    anonymousUserId,
    sessionId,
    experimentVersion: GAME_CONFIG.defaultVersion,
    configVersion: 'default',
  };

  try {
    const response = await fetch(`${API_URL}/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        anonymousUserId,
        sessionId,
        platform,
        trafficSource,
        urlVersion,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = (await response.json()) as SessionResponse;
    return data;
  } catch (err) {
    console.warn('[Session] API failed, using default', err);
    return defaultResponse;
  }
}

function getUrlVersion(): string | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  return params.get('version');
}

function getTrafficSource(): string {
  if (typeof window === 'undefined') return 'direct';
  const params = new URLSearchParams(window.location.search);
  return params.get('source') || 'direct';
}
